import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import {
    toggleWorkWindow, visibleWorkWindow,
    updateWorkWindowConfig, getFieldWorkWindowCancel, getGeoFieldReport
} from '../../../actions/geo';
import { Unit } from '../../../helpers/unit';
import { WorkedAcres, WorkWindowConfiguration } from './utils';
import ShapeName from './ShapeName';
import { PLANTING_PLAN_TYPE_ID } from '../../../constants';

class ShapePopupThree extends React.Component {
    constructor() {
        super();

        this.unit = Unit.getInstance();
        this.state = {
            config: null
        };

        this.handleToggle = this.handleToggle.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.onChangeText = this.onChangeText.bind(this);
        this.onChangeNumber = this.onChangeNumber.bind(this);
    }

    componentDidMount() {
        const { defaultConfiguration, farmConfiguration, wwInfo } = this.props;
        const defaultConfig = this.parseFromWorkWindowConfig(defaultConfiguration);
        const farmConfig = this.parseFromWorkWindowConfig(farmConfiguration);
        const shapeConfig = wwInfo ? this.parseFromWorkWindowConfig(wwInfo.config) : null;
        const { from, to } = this.props.search.custom;
        const startDate = moment.utc(from).startOf('day').format();
        const endDate = moment.utc(to).endOf('day').format();
        const params = {
            farm_uuid: this.props.shape.farmId,
            geo_region_uuid: this.props.shape.shapeGroupId,
            range_type: this.props.planTypeId === PLANTING_PLAN_TYPE_ID ? this.props.search.range : "todate",
            plan_type_id: this.props.planTypeId,
            ...(this.props.search.range !== 'todate' ? {
                start_date: startDate ? startDate : null,
                end_date: endDate ? endDate : null
            } : {})

        }
        this.props.actions.getGeoFieldReport(params)

        this.setState({ config: { ...defaultConfig, ...farmConfig, ...shapeConfig } }, () => {
            this.props.drawingTool.workWindow.getWorkWindow(this.props.shape);
        });
    }

    handleUpdate() {
        const { config } = this.state;
        const reqConfig = this.parseToWorkWindowConfig(config);
        this.props.actions.updateWorkWindowConfig(this.props.shape.shapeRefId, reqConfig);
        this.props.drawingTool.workWindow.getWorkWindow({
            ...this.props.shape, config: reqConfig
        }, true);
    }

    parseFromWorkWindowConfig(config) {
        if (!config) return null;
        const from = {
            gridType: config.grid_type,
            minCellWidth: config.min_cell_width_meters,
            fieldOverlap: config.min_field_overlap_percent,
            widthMultipler: config.work_window_width_multiplier,
            cellComplete: config.cell_complete_percent,
            includeGrid: config.include_grid,
            includeWorkWindow: config.include_work_windows
        }
        return from;
    }

    parseToWorkWindowConfig(config) {
        if (!config) return null;
        const to = {
            grid_type: config.gridType,
            min_cell_width_meters: config.minCellWidth,
            min_field_overlap_percent: config.fieldOverlap,
            work_window_width_multiplier: config.widthMultipler,
            cell_complete_percent: config.cellComplete,
            include_grid: config.includeGrid,
            include_work_windows: config.includeWorkWindow
        }
        return to;
    }

    handleToggle(e) {
        const checked = e.target.checked;
        this.props.drawingTool.workWindow.visibleWorkWindow(this.props.shape.id, checked);
        this.props.actions.toggleWorkWindow(this.props.shape.shapeRefId, checked);
    }

    onChangeText(value, type) {
        this.setState({
            config: {
                ...this.state.config,
                [type]: value
            }
        });
    }

    onChangeNumber(value, type) {
        this.setState({
            config: {
                ...this.state.config,
                [type]: isNaN(value) ? 0 : value
            }
        });
    }

    componentWillUnmount() {
        if (this.props.wwInfo && this.props.wwInfo.isRequesting)
            this.props.actions.getFieldWorkWindowCancel(this.props.shape.shapeRefId);
        else {
            this.props.actions.visibleWorkWindow(this.props.shape.shapeRefId, false);
            this.props.drawingTool.workWindow.removeWorkWindow(this.props.shape.id, false);
        }
    }

    render() {
        const { settings, drawingTool, wwInfo, defaultConfiguration, fieldReport, fieldReportRequesting, farmConfiguration, timezone, ...rootProps } = this.props;
        const { shape } = this.props;
        const { config } = this.state;
        const varietyName = drawingTool && drawingTool.shapeGroups && drawingTool.shapeGroups[shape.shapeGroupId] && drawingTool.shapeGroups[shape.shapeGroupId].variety ? drawingTool.shapeGroups[shape.shapeGroupId].variety : null;
        const totalFieldAcres = wwInfo && wwInfo.totalAcres ? wwInfo.totalAcres : 0;

        return <ShapeName {...rootProps} fieldReport={fieldReport} fieldReportRequesting={fieldReportRequesting} varietyName={varietyName} totalAcres={totalFieldAcres}>
            {({ shapeName, shapeDetail, shapeReport, totalArea, customerName }) => {

                return <div className="shape-popup shape-popup-three">
                    <div className="shape-popup-body">
                        <div className="shape-popup-title">
                            <div>
                                <div>{shapeName}</div>
                                <div className='customer-name text-muted text-truncate' title={customerName}>{customerName}</div>
                            </div>
                        </div>
                        <div className="shape-popup-detail">
                            {shapeDetail}
                            {shapeReport}
                            <WorkedAcres
                                shape={shape}
                                wwInfo={wwInfo}
                                unit={this.unit}
                                settings={settings}
                                totalArea={totalArea}
                                timezone={timezone}
                                handleToggle={this.handleToggle}
                            />
                            {config &&
                                <WorkWindowConfiguration
                                    config={config}
                                    onChangeText={this.onChangeText}
                                    onChangeNumber={this.onChangeNumber}
                                    onUpdate={this.handleUpdate}
                                />}
                        </div>
                    </div>
                </div>;
            }}
        </ShapeName>;
    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        visibleWorkWindow, toggleWorkWindow,
        updateWorkWindowConfig, getFieldWorkWindowCancel, getGeoFieldReport
    }, dispatch)
});

const mapStateToProps = (state, ownProps) => {
    const wwConfig = state.geo.workWindowConfigById[ownProps.shape.farmId];
    return {
        settings: state.user.settings,
        timezone: state.farm.currentFarm.timezone_identifier,
        fieldReport: state.geo.geoFieldReport.payload,
        fieldReportRequesting: state.geo.geoFieldReport.isRequesting,
        wwInfo: state.geo.fieldWorkWindowById.hasOwnProperty(ownProps.shape.shapeRefId) ?
            state.geo.fieldWorkWindowById[ownProps.shape.shapeRefId] : null,
        defaultConfiguration: state.geo.defaultWorkWindowConfig,
        farmConfiguration: wwConfig && wwConfig.configuration ? wwConfig.configuration : null,
        planTypeId: state.plan.selectedPlanType,
        search: {
            range: state.analyze.searchParams.range,
            custom: state.analyze.searchParams.custom
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShapePopupThree);